/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptioninde3Inputs */

const en_eventdescriptioninde3 = /** @type {(inputs: Eventdescriptioninde3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description in German`)
};

const de_eventdescriptioninde3 = /** @type {(inputs: Eventdescriptioninde3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beschreibung auf Deutsch`)
};

/**
* | output |
* | --- |
* | "Description in German" |
*
* @param {Eventdescriptioninde3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptioninde3 = /** @type {((inputs?: Eventdescriptioninde3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptioninde3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptioninde3(inputs)
	return de_eventdescriptioninde3(inputs)
});
export { eventdescriptioninde3 as "eventDescriptionInDe" }